namespace Shared

type ARBucket =
  { Label: string
    From: int option
    To: int option }

type OverviewSettings =
  { CostsLabel: string
    ProfitLabel: string
    GPPerLabel: string }
  static member Default =
    { CostsLabel = "Costs"
      ProfitLabel = "Profit"
      GPPerLabel = "GP%" }

type PurchaseOrderSettingsMode = Basic | OrderItemReport
type PurchaseOrderSettings =
  { Requests: bool
    Version: PurchaseOrderSettingsMode }
  static member Default =
    { Requests = false
      Version = Basic }

type ContractSettings =
  { Projections: bool
    PurchaseOrderSettings: PurchaseOrderSettings
    CostAndBillingForecasting: bool
    ARBuckets: ARBucket list
    OverviewSettings: OverviewSettings }
  static member Default =
    { Projections = false
      PurchaseOrderSettings = PurchaseOrderSettings.Default
      CostAndBillingForecasting = false
      ARBuckets =
        [ { Label = "Future"
            From = None
            To = Some -1 }
          { Label = "Current"
            From = Some 0
            To = Some 30 }
          { Label = "31 - 60"
            From = Some 31
            To = Some 60 }
          { Label = "61 - 90"
            From = Some 61
            To = Some 90 }
          { Label = "Over 90"
            From = Some 90
            To = None } ]
      OverviewSettings = OverviewSettings.Default }

type HomeSettings =
  { AverageLaborRate: bool
    BillingAndCostGPPercent: bool
    Bucket: ARBucket }
  static member Default =
    { AverageLaborRate = false
      BillingAndCostGPPercent = false
      Bucket = HomeSettings.DefaultHomeBucket }

  static member DefaultHomeBucket =
    { From = Some 60
      To = None
      Label = "AR Over 60 Days" }

type ApplicationSettings =
  { ContractSettings: ContractSettings
    AverageLaborRate_RemainingHours: bool
    HomeSettings: HomeSettings
    CompanyTab: bool
    BillingRequestEmail: string option }
  static member Default =
    { ContractSettings = ContractSettings.Default
      AverageLaborRate_RemainingHours = false
      HomeSettings = HomeSettings.Default
      CompanyTab = false
      BillingRequestEmail = None }